import { Grid } from '@mui/material';
import React from 'react';
import { WeekDays } from '~/Models/DTO/Provider.model';
import { OpeningHoursSectionStyles } from '..';
import { IErrorWeekdays } from '../OpeningHoursSection';
import {
  OpeningHoursSectionTableCloseRow,
  OpeningHoursSectionTableHeader,
  OpeningHoursSectionTableRow,
} from '.';

export interface OpeningHoursSectionTableDesktopProps {
  weekdays: string[];
  displayWeekdays: WeekDays;
  errorWeekdays: IErrorWeekdays;
  onToggleDay: (day: string, timeIndex?: number) => void;
  onAddTime: (day: string) => void;
  onTimeChange: (day: string, timeRowIndex: number, type: 'from' | 'to', value: any) => void;
  onCopyToAll: () => void;
}

export const OpeningHoursSectionTableDesktop = ({
  weekdays,
  displayWeekdays,
  onToggleDay,
  onAddTime,
  onTimeChange,
  onCopyToAll,
  errorWeekdays,
}: OpeningHoursSectionTableDesktopProps) => {
  const { classes } = OpeningHoursSectionStyles();

  return (
    <div className={classes.container}>
      <React.Fragment>
        <OpeningHoursSectionTableHeader />

        {weekdays.map((day, dayIndex) => (
          <Grid
            data-testid="opening-hours-section-days"
            key={day}
            container
            className={classes.row}
          >
            {displayWeekdays[day].length > 0 ? (
              <OpeningHoursSectionTableRow
                dataTable={displayWeekdays[day]}
                currentDay={day}
                dayIndex={dayIndex}
                errorWeekdays={errorWeekdays}
                onToggleDay={onToggleDay}
                onTimeChange={onTimeChange}
                onAddTime={onAddTime}
                onCopyToAll={onCopyToAll}
              />
            ) : (
              <OpeningHoursSectionTableCloseRow currentDay={day} onToggleDay={onToggleDay} />
            )}
          </Grid>
        ))}
      </React.Fragment>
    </div>
  );
};
